import { type DeviceEntity, type SiteId } from '@solinkcorp/api-types';
import { useEffect } from 'react';
import { useControllerState } from 'solox';
import { type CamerasDictionary, type VideoDiscoverySite } from 'utils/types';
import { type PlayingCamerasController } from './PlayingCamerasController';

interface SyncPlayingCamerasProps {
  playingCamerasController: PlayingCamerasController;
  camerasById: CamerasDictionary;
  sitesById?: { [siteId: SiteId]: VideoDiscoverySite } | undefined;
  devicesById: Record<string, DeviceEntity> | undefined;
}
// Updates the playing cameras in the controller to have all the camera + location info
export function useSyncPlayingCameras({
  playingCamerasController,
  camerasById,
  sitesById,
  devicesById,
}: SyncPlayingCamerasProps) {
  const playingCameraIds = useControllerState(
    playingCamerasController.state,
    (state) => state.playingCameraIds,
  );

  useEffect(() => {
    playingCamerasController.syncPlayingCameras(
      sitesById,
      camerasById,
      playingCameraIds,
      devicesById,
    );
  }, [camerasById, sitesById, playingCameraIds, playingCamerasController, devicesById]);
}
